const RadioOutput = props => {
    const value = props.value ?? props.question.value;
    const selected = props.question.options.find(x => x.key === value);

    return selected ? selected.value : '';
};

export default RadioOutput;
